import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../../utils/apiConfig';

/**
 * PendingWorksheets - Widget "Feuilles à compléter" pour Chef d'équipe
 */
const PendingWorksheets = ({ token, onNavigate }) => {
  const [worksheets, setWorksheets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWorksheets = async () => {
      if (!token) return;

      setLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/dashboard/pending-worksheets`,
          {
            headers: { 'Authorization': `Bearer ${token}` }
          }
        );

        if (!response.ok) throw new Error('Erreur de chargement');

        const data = await response.json();
        setWorksheets(data.success ? data.data : []);
      } catch (err) {
        console.error('Erreur fetch worksheets:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchWorksheets();
  }, [token]);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <h4 style={styles.title}>Feuilles à compléter</h4>
        <div style={styles.loading}>Chargement...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.container}>
        <h4 style={styles.title}>Feuilles à compléter</h4>
        <div style={styles.error}>{error}</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h4 style={styles.title}>
          Feuilles à compléter
          {worksheets.length > 0 && (
            <span style={styles.count}>({worksheets.length})</span>
          )}
        </h4>
        <button
          style={styles.viewButton}
          onClick={() => onNavigate && onNavigate('worksheets')}
        >
          Voir toutes
        </button>
      </div>

      {worksheets.length === 0 ? (
        <div style={styles.empty}>
          <span style={styles.emptyIcon}>✅</span>
          <p style={styles.emptyText}>Toutes les feuilles sont complétées</p>
        </div>
      ) : (
        <div style={styles.list}>
          {worksheets.slice(0, 5).map((ws) => (
            <div key={ws.id} style={styles.worksheetItem}>
              <div style={styles.worksheetInfo}>
                <span style={styles.prestationNumber}>{ws.prestation_number}</span>
                <span style={styles.worksheetDate}>{formatDate(ws.worksheet_date)}</span>
                <span style={styles.clientName}>{ws.client_name}</span>
              </div>
              <button
                style={styles.completeButton}
                onClick={() => onNavigate && onNavigate('worksheets')}
              >
                Compléter
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  title: {
    margin: 0,
    fontSize: '1.1rem',
    fontWeight: '600',
    color: '#1a1a2e',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  count: {
    backgroundColor: '#dc3545',
    color: 'white',
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '0.85rem',
    fontWeight: '500'
  },
  viewButton: {
    background: 'none',
    border: 'none',
    color: '#6366f1',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '500'
  },
  loading: {
    textAlign: 'center',
    padding: '30px',
    color: '#6c757d'
  },
  error: {
    padding: '20px',
    backgroundColor: '#fff5f5',
    borderRadius: '8px',
    color: '#dc3545',
    textAlign: 'center'
  },
  empty: {
    textAlign: 'center',
    padding: '30px'
  },
  emptyIcon: {
    fontSize: '2rem',
    display: 'block',
    marginBottom: '8px'
  },
  emptyText: {
    margin: 0,
    color: '#6c757d'
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  worksheetItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    backgroundColor: '#fff8e1',
    borderRadius: '8px',
    border: '1px solid #ffe082'
  },
  worksheetInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap'
  },
  prestationNumber: {
    fontWeight: '600',
    fontSize: '0.9rem',
    color: '#1a1a2e'
  },
  worksheetDate: {
    fontSize: '0.85rem',
    color: '#6c757d'
  },
  clientName: {
    fontSize: '0.85rem',
    color: '#6c757d'
  },
  completeButton: {
    padding: '6px 12px',
    backgroundColor: '#ffc107',
    color: '#000',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: '500'
  }
};

export default PendingWorksheets;
